
  let userLocation = null;

  async function fetchUserLocation() {
    if (userLocation) return userLocation;

    try {
      const res = await fetch("https://ipinfo.io/json?token=7c277f5071e26d");
      userLocation = await res.json();
    } catch (err) {
      console.error("Failed to fetch IP location", err);
      userLocation = {};
    }
    return userLocation;
  }

  async function updateCurrencyByLocation() {
    try {
      const locationData = await fetchUserLocation();
      const countryCode = locationData.country;
      // console.log("countryCode: ", countryCode);
      if (!countryCode) throw new Error("Country code not found");

      // Flag update
      const flagImage = document.getElementById('country-flag');
      if (flagImage) {
        flagImage.src = `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;
        flagImage.alt = `${countryCode} Flag`;
      }

      // Currency info
      const countryRes = await fetch(`https://restcountries.com/v3.1/alpha/${countryCode}`);
      const countryData = await countryRes.json();
      const currencyInfo = countryData[0]?.currencies;
      if (!currencyInfo) throw new Error("Currency information not found");

      const currencyCode = Object.keys(currencyInfo)[0];
      const currencySwitcher = document.querySelector('.currency-switcher');
      if (!currencySwitcher) return;

      let selectedCountry = "";
      let found = false;

      currencySwitcher.querySelectorAll('option').forEach(option => {
        if (option.getAttribute('data-display') === currencyCode) {
          option.selected = true;
          selectedCountry = option.getAttribute('data-country');
          found = true;
        }
      });

      if (!found) return;

      currencySwitcher.dispatchEvent(new Event('change'));
      updateCurrentDisplay(selectedCountry, currencyCode);

      // Update URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('country', countryCode.toUpperCase());
      window.history.replaceState({}, '', newUrl);

      updateCountryOptions(currencyCode);
    } catch (error) {
      console.error(`Error while updating currency: ${error.message}`, error);
    }
  }

  function updateCountryOptions(currencyCode) {
    const countrySelect = document.getElementById("country");
    const currencySwitcher = document.querySelector(".currency-switcher");
    if (!currencySwitcher || !countrySelect) return;

    countrySelect.innerHTML = '';
    currencySwitcher.querySelectorAll("option").forEach(option => {
      const newOption = document.createElement("option");
      Array.from(option.attributes).forEach(attr => newOption.setAttribute(attr.name, attr.value));
      newOption.textContent = option.getAttribute("data-country").replace(/-/g, ' ');
      if (option.getAttribute('data-display') === currencyCode) newOption.selected = true;
      countrySelect.appendChild(newOption);
    });
  }

  function updateCurrentDisplay(countryName, currencyCode) {
    const display = document.querySelector(".current.notranslate");
    if (display) {
      const flagClass = `flags flags-${countryName.trim().replace(/\s+/g, "-")}`;
      display.innerHTML = `<span class="${flagClass}"></span> &nbsp;${currencyCode}`;
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateCurrencyByLocation();

    const shopNowBtn = document.getElementById("shop-now");
    const countrySelect = document.getElementById("country");
    const flagElement = document.getElementById("country-flag");
    const popup = document.getElementById("popup");
    const overlay = document.getElementById("overlay");

    shopNowBtn.addEventListener("click", () => {
      const currencySwitcher = document.querySelector(".currency-switcher");
      const selectedOption = countrySelect.options[countrySelect.selectedIndex];
      const selectedCountry = selectedOption?.getAttribute("data-country");
      const selectedCountryCode = window.CountryNameToCode?.[selectedCountry.trim()] || selectedCountry;

      if (!selectedCountryCode) return alert("Please select country!");

      // Update URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("country", selectedCountryCode.toUpperCase());
      window.history.replaceState({}, "", newUrl);

      // Update flag
      if (flagElement) {
        flagElement.src = `https://flagcdn.com/w40/${selectedCountryCode.toLowerCase()}.png`;
        flagElement.alt = `${selectedCountryCode} Flag`;
      }

      // Update currency
      if (currencySwitcher) {
        let found = false;
        let currencyCode = "";
        currencySwitcher.querySelectorAll("option").forEach(option => {
          if (option.getAttribute("data-country") === selectedCountry) {
            option.selected = true;
            currencyCode = option.getAttribute("data-display");
            found = true;
          }
        });

        if (!found) return console.log("Country not found in option list");

        currencySwitcher.dispatchEvent(new Event("change"));
        updateCurrentDisplay(selectedCountry, currencyCode);
      }

      if (popup) popup.style.display = "none";
      if (overlay) overlay.style.display = "none";
    });
  });

  // ========== Google Translate ==========
  function googleTranslateElementInit() {
    new google.translate.TranslateElement({
      pageLanguage: 'xx',
      layout: google.translate.TranslateElement.InlineLayout.VERTICAL,
      autoDisplay: false
    }, 'google_translate_element');

    syncLanguageDropdown();
    detectAndSetLanguage();
  }

  async function detectAndSetLanguage(retryCount = 0) {
    const googleSelect = document.querySelector(".goog-te-combo");
    if (!googleSelect || googleSelect.options.length < 1) {
      if (retryCount < 20) return setTimeout(() => detectAndSetLanguage(retryCount + 1), 300);
      return;
    }

    try {
      const data = await fetchUserLocation();
      const langCode = data?.country ? countryToLanguage(data.country) : (navigator.language || "en").split("-")[0];
      // console.log("langCode:", langCode);
      const supported = googleSelect.querySelector(`option[value="${langCode}"]`);
      if (supported) {
        googleSelect.value = langCode;
        googleSelect.dispatchEvent(new Event("change"));
        // console.log("Updated googleSelect.value:", googleSelect.value);

        setTimeout(() => {
          if (googleSelect.value !== langCode) {
            googleSelect.value = langCode;
            googleSelect.dispatchEvent(new Event("change"));
          }
        }, 1000);
      }
    } catch (err) {
      console.error("Auto language detection failed", err);
    }
  }

  function syncLanguageDropdown(retryCount = 0) {
    const googleSelect = document.querySelector('.goog-te-combo');
    const customSelect = document.getElementById('languages');

    if (!googleSelect || !customSelect || googleSelect.options.length < 1) {
      if (retryCount < 20) return setTimeout(() => syncLanguageDropdown(retryCount + 1), 300);
      return;
    }

    customSelect.addEventListener('change', () => {
      googleSelect.value = customSelect.value;
      googleSelect.dispatchEvent(new Event('change'));
    });

    customSelect.value = googleSelect.value;

    new MutationObserver(() => {
      customSelect.value = googleSelect.value;
    }).observe(googleSelect, { attributes: true, childList: true, subtree: true });
  }

  function countryToLanguage(code) {
    const map = {
      AF: "fa", AL: "sq", DZ: "ar", AD: "ca", AO: "pt", AR: "es", AM: "hy", AU: "en", AT: "de", AZ: "az",
      BH: "ar", BD: "bn", BY: "be", BE: "nl", BO: "es", BA: "bs", BW: "en", BR: "pt", BG: "bg", KH: "km",
      CM: "fr", CA: "en", CL: "es", CN: "zh-CN", CO: "es", CR: "es", HR: "hr", CY: "el", CZ: "cs", DK: "da",
      DO: "es", EC: "es", EG: "ar", EE: "et", ET: "am", FI: "fi", FR: "fr", GE: "ka", DE: "de", GR: "el",
      GT: "es", HN: "es", HK: "zh-TW", HU: "hu", IS: "is", IN: "hi", ID: "id", IR: "fa", IQ: "ar", IE: "en",
      IL: "he", IT: "it", JM: "en", JP: "ja", JO: "ar", KZ: "kk", KE: "sw", KR: "ko", KW: "ar", LV: "lv",
      LB: "ar", LT: "lt", LU: "fr", MK: "mk", MY: "ms", MT: "mt", MX: "es", MD: "ro", MN: "mn", MA: "ar",
      NP: "ne", NL: "nl", NZ: "en", NI: "es", NG: "en", NO: "no", OM: "ar", PK: "ur", PA: "es", PY: "es",
      PE: "es", PH: "tl", PL: "pl", PT: "pt", QA: "ar", RO: "ro", RU: "ru", SA: "ar", RS: "sr", SG: "en",
      SK: "sk", SI: "sl", ZA: "en", ES: "es", LK: "si", SE: "sv", CH: "de", SY: "ar", TW: "zh-TW", TH: "th",
      TN: "ar", TR: "tr", UA: "uk", AE: "ar", GB: "en", US: "en", UY: "es", UZ: "uz", VE: "es", VN: "vi",
      YE: "ar", ZW: "en"
    };
    return map[code.toUpperCase()] || "en";
  }

  (function loadGoogleTranslate() {
    if (window.google && google.translate) {
      googleTranslateElementInit();
    } else {
      const script = document.createElement('script');
      // script Google Translate
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.head.appendChild(script);
    }
  })();

  // hide text
  window.addEventListener('load', function () {
    const gadgetDiv = document.querySelector('.goog-te-gadget');
    if (gadgetDiv) {
      gadgetDiv.childNodes.forEach(node => {
        if (node.nodeType === 3 && node.textContent.includes("Được hỗ trợ bởi")) {
          node.textContent = '';
        }
      });
    }
  });